module.exports = __webpack_public_path__ + "img/222.missing_hend_sanitizer.25d1df42.svg";